import { gql } from "@apollo/client";

export const MUTATION_CREATE_PODCAST_LISTENING_TIME = gql`
  mutation createPodcastListeningTime($input: PodcastListeningTimeInput!) {
    createPodcastListeningTime(data: $input) {
      id
      documentId
      listeningTime
      duration
    }
  }
`;

export const MUTATION_UPDATE_PODCAST_LISTENING_TIME = gql`
  mutation updatePodcastListeningTime(
    $id: ID!
    $input: PodcastListeningTimeInput!
  ) {
    updatePodcastListeningTime(documentId: $id, data: $input) {
      createdAt
    }
  }
`;
